import * as React from 'react'

function SvgIconSnsTwitter(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M30 2.892a12.808 12.808 0 01-3.544.974A6.128 6.128 0 0029.16.457a12.265 12.265 0 01-3.898 1.492A6.156 6.156 0 0020.77 0c-3.406 0-6.147 2.771-6.147 6.169-.005.473.043.944.143 1.406-5.114-.251-9.638-2.707-12.677-6.45a6.178 6.178 0 001.89 8.242A6.058 6.058 0 011.2 8.608v.067a6.19 6.19 0 004.927 6.06 6.11 6.11 0 01-1.612.203 5.45 5.45 0 01-1.164-.106c.797 2.443 3.058 4.238 5.746 4.296a12.335 12.335 0 01-7.625 2.63C.98 21.76.488 21.733 0 21.674a17.284 17.284 0 009.435 2.766c11.316 0 17.505-9.4 17.505-17.549 0-.273-.01-.536-.023-.797a12.296 12.296 0 003.08-3.202H30z"
        fill="#fff"
      />
    </svg>
  )
}

export default SvgIconSnsTwitter
